import * as ng from 'angular';
import { NumberDecimal } from './number-decimal.directive';


export const NumberDecimalModule: string =
    ng.module('number-decimal', [
    ])
        .directive('numberDecimal', NumberDecimal)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/number-decimal/number-decimal.module.ts